/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Airport,
  AirportRequest,
  FlightRouteRequest,
  FlightRoutes,
  VehicleRentalLocation,
} from '../models/index';
import {
    AirportFromJSON,
    AirportToJSON,
    AirportRequestFromJSON,
    AirportRequestToJSON,
    FlightRouteRequestFromJSON,
    FlightRouteRequestToJSON,
    FlightRoutesFromJSON,
    FlightRoutesToJSON,
    VehicleRentalLocationFromJSON,
    VehicleRentalLocationToJSON,
} from '../models/index';

export interface SearchAirportsNearestGetRequest {
    lat: number;
    lng: number;
    limit?: number;
}

export interface SearchAirportsPostRequest {
    airportRequest: AirportRequest;
}

export interface SearchFlightRoutesPostRequest {
    flightRouteRequest: FlightRouteRequest;
}

export interface SearchVehicleLocationsNearestGetRequest {
    lat: number;
    lng: number;
    radiusKm?: number;
    limit?: number;
}

/**
 * 
 */
export class StaticContentApi extends runtime.BaseAPI {

    /**
     * Returns the nearest airports to a given latitude/longitude
     */
    async searchAirportsNearestGetRaw(requestParameters: SearchAirportsNearestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Airport>>> {
        if (requestParameters['lat'] == null) {
            throw new runtime.RequiredError(
                'lat',
                'Required parameter "lat" was null or undefined when calling searchAirportsNearestGet().'
            );
        }

        if (requestParameters['lng'] == null) {
            throw new runtime.RequiredError(
                'lng',
                'Required parameter "lng" was null or undefined when calling searchAirportsNearestGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lat'] != null) {
            queryParameters['lat'] = requestParameters['lat'];
        }

        if (requestParameters['lng'] != null) {
            queryParameters['lng'] = requestParameters['lng'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/airports/nearest`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AirportFromJSON));
    }

    /**
     * Returns the nearest airports to a given latitude/longitude
     */
    async searchAirportsNearestGet(requestParameters: SearchAirportsNearestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Airport>> {
        const response = await this.searchAirportsNearestGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of airports matching the given query
     */
    async searchAirportsPostRaw(requestParameters: SearchAirportsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Airport>>> {
        if (requestParameters['airportRequest'] == null) {
            throw new runtime.RequiredError(
                'airportRequest',
                'Required parameter "airportRequest" was null or undefined when calling searchAirportsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/airports`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AirportRequestToJSON(requestParameters['airportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AirportFromJSON));
    }

    /**
     * Returns a list of airports matching the given query
     */
    async searchAirportsPost(requestParameters: SearchAirportsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Airport>> {
        const response = await this.searchAirportsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of flight routes matching the given query
     */
    async searchFlightRoutesPostRaw(requestParameters: SearchFlightRoutesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FlightRoutes>>> {
        if (requestParameters['flightRouteRequest'] == null) {
            throw new runtime.RequiredError(
                'flightRouteRequest',
                'Required parameter "flightRouteRequest" was null or undefined when calling searchFlightRoutesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/flight_routes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FlightRouteRequestToJSON(requestParameters['flightRouteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FlightRoutesFromJSON));
    }

    /**
     * Returns a list of flight routes matching the given query
     */
    async searchFlightRoutesPost(requestParameters: SearchFlightRoutesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FlightRoutes>> {
        const response = await this.searchFlightRoutesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns known rental-car desks nearest to a latitude/longitude
     */
    async searchVehicleLocationsNearestGetRaw(requestParameters: SearchVehicleLocationsNearestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleRentalLocation>>> {
        if (requestParameters['lat'] == null) {
            throw new runtime.RequiredError(
                'lat',
                'Required parameter "lat" was null or undefined when calling searchVehicleLocationsNearestGet().'
            );
        }

        if (requestParameters['lng'] == null) {
            throw new runtime.RequiredError(
                'lng',
                'Required parameter "lng" was null or undefined when calling searchVehicleLocationsNearestGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lat'] != null) {
            queryParameters['lat'] = requestParameters['lat'];
        }

        if (requestParameters['lng'] != null) {
            queryParameters['lng'] = requestParameters['lng'];
        }

        if (requestParameters['radiusKm'] != null) {
            queryParameters['radius_km'] = requestParameters['radiusKm'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/vehicle_locations/nearest`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleRentalLocationFromJSON));
    }

    /**
     * Returns known rental-car desks nearest to a latitude/longitude
     */
    async searchVehicleLocationsNearestGet(requestParameters: SearchVehicleLocationsNearestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleRentalLocation>> {
        const response = await this.searchVehicleLocationsNearestGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
